import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { connect } from 'react-redux';
import { change, reduxForm } from 'redux-form';
import { compose, lifecycle, withHandlers, withState } from 'recompose';
import { get } from 'lodash';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import ComposedUpload from '@inqool/uas-web-core/es/components/controls/Upload';

import { Preview } from '@components/form/Upload/Upload';
import { InlineGridField, InlineGrid } from '@components/form';
import { filesGridColumns } from './_eventsColumns';
import { EventsFormFilesForm } from './EventsFormFilesForm';
import { Loader } from '@components/loader';

const mapStateToProps = state => ({
  eventFiles: get(state, 'form.module-events.values.files'),
  files: get(state, 'form.module-events-files.values.files')
});

const mapDispatchToProps = dispatch => ({
  addFilesToEvent: files => dispatch(change('module-events', 'files', files)),
  saveFiles: files => dispatch(change('module-events-files', 'files', files))
});

let inProgressCount = 0;

const enhance = compose<any, any>(
  reduxForm({ form: 'module-events-files', initialValues: { files: [] } }),
  connect(mapStateToProps, mapDispatchToProps),
  withState('inProgress', 'setInProgress', false),
  withHandlers({
    updateProgress:
      ({ setInProgress }) =>
      value => {
        inProgressCount = value < 0 ? 0 : value;
        setInProgress(!!inProgressCount);
      }
  }),
  withHandlers({
    onChange:
      ({ files, saveFiles, updateProgress }) =>
      data => {
        saveFiles([...files, data]);
        updateProgress(inProgressCount - 1);
      },
    onSubmit:
      ({ eventFiles, files, addFilesToEvent, closeItem, setDisableSps }) =>
      () => {
        addFilesToEvent([...eventFiles, ...files]);
        setDisableSps(true);
        closeItem();
      }
  }),
  lifecycle<any, any>({
    componentWillUnmount() {
      this.props.updateProgress(0);
    }
  })
);

const View: any = ({ files, closeItem, onChange, onSubmit, inProgress, updateProgress }) => {
  return (
    <div style={{ margin: '15px', maxHeight: '500px', overflow: 'auto' }}>
      {!!inProgress && <Loader />}
      <Grid fluid={true}>
        <Row className="without-min-width">
          <Col md={12}>
            <InlineGridField
              component={InlineGrid}
              name="files"
              columns={filesGridColumns}
              Form={EventsFormFilesForm}
              ActionBar={() => (
                <div style={{ display: 'flex', alignItems: 'center', height: '36px', cursor: 'pointer' }}>
                  <ComposedUpload
                    value={null}
                    url="/metropolis/api/files/"
                    accept="image/*,video/*"
                    View={Preview}
                    onChange={onChange}
                    fullWidth={true}
                    multiple={true}
                    onStart={f => updateProgress(inProgressCount + f.length)}
                    onError={() => updateProgress(inProgressCount - 1)}
                    onAbort={() => updateProgress(inProgressCount - 1)}
                  />
                </div>
              )}
              showCheckboxes={true}
              deleting={true}
              editing={true}
              adding={false}
            />
          </Col>
        </Row>
      </Grid>

      <Button
        label="Uložit"
        style={{ margin: '16px 0 16px 16px' }}
        onClick={onSubmit}
        primary={true}
        disabled={!files || !files.length}
      />
      <Button label="Zavřít" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
    </div>
  );
};

export const EventsFormFilesMultipleUploader = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormFilesMultipleUploader.tsx